export const environment = {
  production: true,
  apiUrl: 'https://app.inbox.com.pa/API/',
  firebase: {
    apiKey: 'AIzaSyAlfLYmDUVXgHbKfjXJyieWNkZ2Agb57CQ',
    authDomain: 'protean-bazaar-237402.firebaseapp.com',
    databaseURL: 'https://protean-bazaar-237402.firebaseio.com',
    projectId: 'protean-bazaar-237402',
    storageBucket: 'protean-bazaar-237402.appspot.com',
    messagingSenderId: '704956448606',
    provinces: [
      'Bocas del Toro',
      'Coclé',
      'Colón',
      'Chiriqui',
      'Darién',
      'Herrera',
      'Los Santos',
      'Panamá',
      'Panamá Oeste',
      'Veraguas',
    ],
  },
};
